import React, { Component } from 'react';
import { translate } from '../services';
import { ActionPanel, HtmlComponent, ProductCode, ProductImage, ProductPrice, SvgImage, ProductStock, ProductDescription, QuantityField, IconButton,ProductEcoSolution } from '.';
import { PropTypes } from 'prop-types';
import { CloseLightIconNew, TrashWhiteIconNew, closePopup, linkedIcon, linkedIconNew } from '../../style/images';
import { PriceProperty } from './productItem';
import { productState,combineDispatchers, flagDispatcher, mobileItemDetailDispatcher, screenSizeState, combineStates } from '../store';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { Box, Dialog, IconButton as MuiIconButton } from '@mui/material';
import { DetailedModal } from './DetailedModal';
import { getProductLink } from '../util';

export class CustomContentComponent extends Component {
  constructor(){
    super();
    this.state={
      showDialog: false,
      showItemDetails: false,
    }
  }
  toogleItemDetail(){
    // e.stopPropagation()
    this.setState({showItemDetails:!this.state.showItemDetails})
  }

  getDisplayPrice() {
    const { data, layout } = this.props;
    if ( data.configuration && !data.isExpanded ) {
      return data.configurationPrice;
    }
    return data[layout.property];
  }

  toogleLinkedDialog(){
    this.setState({showDialog:!this.state.showDialog})
  }

  getTemplate() {
    const { data, layout,NSTbom_ACC,accessorylength } = this.props;
    let templateType = layout.template.toLowerCase();
    if ( templateType === 'cartallactions' && ( !data.isSuperConfiguration && !data.additionalProducts && data.configuration ) ) {
      if( !data.configuration.materialKey || (data.configuration.materialKey && data.configuration.materialKey.includes('ACC_PF_') ) ) {
        templateType = 'cartfpview';
      }
    }
    if ( templateType === 'cartallactions' && ( data.isSuperConfiguration ) ) {
      templateType = 'cartsuperconfigview';
    }
    switch ( templateType ) {
      case 'linkedicon':
        return <div className='round-button' onClick={(e)=>{e.stopPropagation();this.toogleLinkedDialog()}}>
                <SvgImage source={ linkedIconNew } toolTip={ translate( 'This item is linked to another one' ) }/>
              </div>;
      case 'acessoryactions':
        return<>
          <div className="delete-icon">
          <IconButton className={ classNames( "white-round-button") } toolTip={ translate( 'Remove assignment' ) }  icon={TrashWhiteIconNew} onClick={ ()=>{this.props.enableRemoveMethodForConfigurator(this.props.title?this.props.title:"") } } />
          </div>
        </>
      case 'cartdeleteicon':
        return <ActionPanel currentSelector={this.props.currentSelector} fromCart remove product={ data } />;
      case 'cartactions':
        return <ActionPanel currentSelector={this.props.currentSelector} configure clone fromCart quantity product={ data } />;
      case 'cartallactions':
        return <ActionPanel currentSelector={this.props.currentSelector} warning configure clone fromCart quantity remove product={ data } handleCommentUpdate={this.props.handleCommentUpdate}/>;
      case 'cartfpview':
        return <ActionPanel currentSelector={this.props.currentSelector} fromCart product={ data } />;
      case 'cartsuperconfigview':
        return <ActionPanel currentSelector={this.props.currentSelector} quantity remove fromCart product={ data } />;
      case 'availability':
        return <ProductStock layout={layout} product ={ data }  currentView= { this.props.currentView }/>;
      case 'stock':
        return <ProductStock fromStock product ={ data } currentView= { this.props.currentView } />;
      case 'cartavailability':
        return <ProductStock fromCart layout={layout} product ={ data }  currentView= { this.props.currentView }/>;
      case 'productimage':
        return <ProductImage product={ data } alt={ data.productCode } className="small-image" />;
      case 'largeproductimage':
        return <ProductImage onClick={()=>{this.toogleItemDetail()}}  product={ data } alt={ data.productCode } className="full-image" />;
      case 'productactions':
        // return <ActionPanel configure quantity add product={ data } />;
        return <ActionPanel currentSelector={this.props.currentSelector} showQuantityView={false} configure quantity add product={ data } mobileSearchView={this.props.mobileSearchView} fromLooseAccessories={this.props.view==="looseaccessories"} fromSelect/>;
      case 'productcode':
        return <ProductCode { ...data } accessorylength={accessorylength} />;
      case 'ecosolution':
        return <ProductEcoSolution product={ data } />;
      case 'cartformattedprice':
        return <ProductPrice fromCart product={ data } layout={layout}  currentView= { this.props.currentView } />;
      case 'formattedprice':
        return <ProductPrice product={ data } layout={layout} fromSelect currentView= { this.props.currentView } />;
      case 'listprice':
        return <ProductPrice product={ data } showListPrice layout={layout}  currentView= { this.props.currentView }/>;
      case 'netprice':
        return <ProductPrice product={ data } showNetPrice layout={layout}  currentView= { this.props.currentView }/>;
      case 'showpriceperunit':
          return <ProductPrice product={ data } showPricePerUnit layout={layout}  currentView= { this.props.currentView }/>;
      case 'searchactions':
        return <ActionPanel currentSelector={this.props.currentSelector} showQuantityView={false} configure quantity add fromSearch fromSearchOverlay={this.props.view==="searchproduct"} mobileSearchView={this.props.mobileSearchView} product={ data } />;
      case 'modelconfiguratorquantity':
        return <ActionPanel currentSelector={this.props.currentSelector} quantity={ {readonly: false} } defaultAmount={ 0 } fromModelConfigurator product={ data } modelconfiguratorquantity />;
      case 'priceproperty':
        return <PriceProperty product={ data } property={ layout.property } />
      case 'productdescription':
          return <ProductDescription product={ data } NSTbom_ACC={NSTbom_ACC}/>;
      case 'shortdescriptioncn':
          return <ProductDescription product={ data } NSTbom_ACC={NSTbom_ACC} shortdescriptioncn/>;
      case 'searchquantity':
        return <QuantityField showQuantityView={true} configure quantity add fromSearch product={ data }></QuantityField>
      default:
        console.error( `template not found: ${ layout.template }` );
        return null;
    }
  }

  render() {
    const { layout, data,accessorylength } = this.props;
    let Content = null;

    switch ( layout.type ) {
      case 0:
        //text
        const text = data[layout.property] || '';
        //if local MM code property is there then attach Global MM code for product link
        const link = layout.property=='materialNameLso' && !(data?.name?.startsWith('V')) && getProductLink( data.name );
        const className = layout.property && layout.property.toLowerCase().startsWith( 'description' ) ? 'wrap-description' : 
            classNames("ellipsed",{"product-bold-font":layout.className==="bold-font", "light-font":layout.className==="light-font"});
        const translated = layout.isTranslatable ? translate( text ) : text;
        Content = link?<a href={ link } target="_blank"><span className={ className } title={ translated }>{ translated }</span></a>:
        <span className={ className } title={ translated }>{ translated }</span>;
        break;
      case 1:
        //template
        Content = this.getTemplate();
        break;
      case 2:
        //method
        const title = layout.title && translate( layout.title );
        const innerContent = new Function( 'translate', 'item', layout.data )( translate, data );
        const classes = classNames("ellipsed",{"product-bold-font":layout.className==="bold-font", "light-font":layout.className==="light-font"})
        Content = <HtmlComponent className={classes} tooltip={ title || innerContent } item={ innerContent } autoTranslate={ false } />;
        break;
    }

    return <>{Content}
      {!this.props.fromDetailedView&&this.props.screenSize.width<=900&&<DetailedModal item={data} showItemDetails={this.state.showItemDetails} toogleItemDetail={()=>{this.toogleItemDetail()}} accessorylength={accessorylength}></DetailedModal>}
      <Dialog id='linked-icon' fullWidth sx={{display:{md:"none", xs:"flex"}, width:"100vw"}}
       PaperProps={{sx:{width:"100%", maxWidth:"100%", margin:"24px"}}}
      open={this.state.showDialog} onClose={()=>{this.toogleLinkedDialog()}}>
        <div className="linked-icon-container">
        <MuiIconButton disableFocusRipple disableRipple disableTouchRipple onClick={()=>{this.toogleLinkedDialog()}} style={{width:"18px", height:"18px"}} sx={{display:"flex",position:"absolute", top:"12px", right:"12px", background:"#F5F5F5", height:"20px", width:"20px", borderRadius:"56px" , backgroundColor: 'white'}}>
              <Box component="img" src={closePopup} sx={{height:"18px", width:"18px"}}></Box>
            </MuiIconButton>
          <div className="linked-item">
            {translate("Linked item")}
          </div>
          <div className="message">
            {translate("This item is linked to another one.")}
          </div>
          <div className='footer'>
            <div className='footer-button' onClick={()=>{this.toogleLinkedDialog()}}>
              <span>{translate("Okay")}</span>
            </div>
          </div>
        </div>
      </Dialog>
    </>;
  }
}

CustomContentComponent.propTypes = {
  data: PropTypes.shape( {} ).isRequired,
  layout: PropTypes.shape( {
    data: PropTypes.string,
    property: PropTypes.string,
    template: PropTypes.string,
    type: PropTypes.number.isRequired
  } ).isRequired
};

export const CustomContent = connect(combineStates( productState,screenSizeState),combineDispatchers( mobileItemDetailDispatcher, flagDispatcher))(CustomContentComponent);